'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasr';
var iconName = 'dumpster';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'f793';
var svgPathData = 'M32 64L0 192 106.7 192 132.3 64 32 64zM264 192l0-128-82.7 0-25.6 128 108.3 0zm48 0l108.3 0-25.6-128-82.7 0 0 128zm157.3 0l106.7 0-32-128-100.3 0 25.6 128zM56 240l-28.1 0 4.4 27.8 32 200 2 12.2 48.6 0-7.7-48 361.6 0c-3.2 20.2-5.8 36.2-7.7 48l48.6 0 2-12.2 32-200 4.4-27.8-492.1 0zM476.5 384l-377 0-15.4-96 407.7 0-15.4 96z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faDumpster = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;